'use strict';

class CInputMoneyController {
    constructor() {
      'ngInject';
    }

    $onInit() {
  }
}
export default CInputMoneyController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-input-money/c-input-money.controller.js